import axios from 'axios'
import {isAfter, addHours, isBefore} from 'date-fns'
import Cookies from 'js-cookie'
import {getLanguageFromLanguages, getApiUrl} from './helpers'
import * as storage from '../Services/storage.jsx'
import * as hb_api from '../Services/hb_api.jsx'
import * as hubspot from '../Services/hubspot_api.jsx'
import { getEnvVar } from '../config/env.js'
import {getBaseLanguageCode} from './helpers.jsx'

import {convertDateWithTimezone} from './helpers.jsx' //eslint-disable-line

window.API_URL = getApiUrl()
window.storage = storage

// Funzione per ottenere i cookie con fallback
const getCookie = (key) => {
  const envKey = getEnvVar(key.replace(/^VITE_/, ''));
  return Cookies.get(envKey) || '';
};

const rawQuoteToQuote = (quote, quoteKind) => {
  if (quote && quote['id_project']) {
    const result = {
      id: quote['id_project'],
      code: quote.code,
      quoteKind: quoteKind,
      deliveryDate: new Date(quote['delivery_date']),
      price: quote.total || 0,
      words: quote.words || 0,
    }
    return result
  } else return undefined
}

export const getQuote = async ({
  source,
  target,
  words,
  subject,
  when,
  kind,
}) => {
  const params = {
    words,
    source,
    target: target.join(','),
    type: kind,
    subject,
    _cookie_utm: getCookie('VITE_COOKIE_UTM'),
    _cookie_sem: getCookie('VITE_COOKIE_SEM'),
  }

  if (kind !== quoteKinds.lara && kind !== quoteKinds.laraHR) {
    params.delivery_date = when || ''
  }

  for (const key in params) if (!params[key]) delete params[key]

  const {data: result} = await axios.get(
    getApiUrl() + '/quote/create',
    {params},
  )
  return rawQuoteToQuote(result, kind)
}

export const quoteKinds = {
  postediting: 'postediting',
  translation: 'translation',
  translationRevision: 'translation+revision',
  transcreation: 'transcreation',
  lara: 'lara_instant',
  laraHR: 'lara_hr',
}

export const confirmQuote = async (
  customerId,
  projectId,
  sendTo,
  projectName,
  noteToTranslator,
  selectedCurrency,
  files,
  wordCountToolUsed,
  quoteKind,
  newUser = null,
) => {
  const data = {
    id_customer: customerId,
    id_project: projectId,
    send_to: sendTo,
    project_name: projectName,
    note_to_translator: noteToTranslator,
    currency: selectedCurrency.currency,
    rate: selectedCurrency.rate,
    files,
    timezone:
      Intl.DateTimeFormat().resolvedOptions().timeZone ||
      Math.round(new Date().getTimezoneOffset() / 60), //IE11 fix
    wordCountToolUsed,
    _cookie_utm: getCookie('VITE_COOKIE_UTM'),
    _cookie_sem: getCookie('VITE_COOKIE_SEM'),
  }

  for (const key in data) if (!data[key]) delete data[key]

  if (!data.rate) {
    const rates = await getRates()
    data.rate = data.currency === 'EUR' ? 1 : rates[data.currency]
  }

  const {data: result} = await axios.post(
    getApiUrl() + '/quote/confirm',
    data,
  )

  let price = storage.getSelectedQuote().price
  const {data: me} = await axios.post(getApiUrl() + '/customer/me')
  let email = me.email

  await Promise.allSettled([
    hb_api.hb_trackPurchase(email, projectId, price, sendTo),
    hubspot.hbapi_trackPurchase(
      email,
      projectId,
      price,
      sendTo,
      projectName,
      newUser,
    ),
  ])

  // marketing trap (tofix: support ie11)
  window.document.dispatchEvent(
    new CustomEvent('confirm', {detail: {...result, type: quoteKind}}),
  )

  return {projectId: result.id_project}
}

export const getQuoteMetaFromCode = async (
  code,
  languages,
  selectedTimeZone,
) => {
  const {data: response} = await axios.post(
    getApiUrl() + '/quote/getMetadata',
    {code},
  )

  const source = response.source
  const targets = response.targets
  const subject = response.subject
  const words = response.words

  const haveDeliveryDate = isAfter(
    convertDateWithTimezone(new Date(response.delivery), selectedTimeZone),
    convertDateWithTimezone(new Date(), selectedTimeZone),
  )

  const date = selectedTimeZone
    ? convertDateWithTimezone(new Date(response.delivery), selectedTimeZone)
    : new Date(response.delivery)

  const deliveryDate = {
    isAuto: !haveDeliveryDate,
    date: haveDeliveryDate ? date : undefined,
    timeZone: haveDeliveryDate ? selectedTimeZone : undefined,
  }

  const sourceLanguage = getLanguageFromLanguages(source, languages)
  const targetLanguages = targets
    .split(',')
    .map((languageId) => getLanguageFromLanguages(languageId, languages))

  return {
    sourceLanguage: sourceLanguage,
    targetLanguages: targetLanguages,
    wordCount: words,
    subject: subject,
    deliveryDate: deliveryDate,
  }
}

export const getRates = async () => {
  const {data} = await axios.post(getApiUrl() + '/utils/getRates')
  return data
}

export const createUser = async (user) => {
  const data = {
    id_customer: user.userName,
    is_business: user.is_business,
    password: user.password,
    email: user.email,
    name: user.name,
    telephone: user.telephone,
    timezone: user.timezone.id,
    admin_email: user.email,
    admin_name: user.billingName,
    company_name: user.companyName,
    vat_code: user.vat,
    fiscal_code: user.fiscalCode,
    address: user.address1,
    address2: user.address2,
    city: user.city,
    country: user.country.id,
    postal_code: user.zip,
    sdi_code: user.sdiCode,
    language: getBaseLanguageCode(document.documentElement.lang),
    _cookie_utm: getCookie('VITE_COOKIE_UTM'),
    _cookie_sem: getCookie('VITE_COOKIE_SEM'),
  }

  const {data: token} = await axios.post(
    getApiUrl() + '/customer/signUp',
    data,
  )
  window.localStorage.setItem('token', token)
  window.localStorage.setItem('currentUserToken@translated.com', token)

  // CONVENTION: first name are the first two element of the > 2 long array. Last name is the rest
  let nameSplit = data.name.split(' ')
  let firstName =
    nameSplit.length > 2
      ? nameSplit.splice(0, 2).join(' ')
      : nameSplit.splice(0, 1).join(' ')
  let lastName = nameSplit.join(' ')

  hb_api.hb_trackSignup(
    data.email,
    firstName,
    lastName,
    data.language,
    data.country,
    data.city,
  )
  hb_api.hb_trackQuotesFromLocalStorage(data.email)
  await hubspot.hbapi_trackQuotesFromLocalStorage(data.email)

  // marketing trap (tofix: support ie11)
  const {data: me} = await axios.post(getApiUrl() + '/customer/me', {
    token,
  })
  window.document.dispatchEvent(
    new CustomEvent('sign-up', {detail: {token, ...me}}),
  )

  return token
}

export const login = async (userName, password) => {
  const params = {
    id_customer: userName,
    password: password,
  }

  try {
    const {data: token} = await axios.post(
      getApiUrl() + '/customer/signIn',
      params,
    )
    
    window.localStorage.setItem('token', token)
    window.localStorage.setItem('currentUserToken@translated.com', token)

    // marketing trap (tofix: support ie11)
    const {data: me} = await axios.post(getApiUrl() + '/customer/me')

    window.document.dispatchEvent(
      new CustomEvent('sign-in', {detail: {token, ...me}}),
    )

    window.Sentry &&
      window.Sentry.configureScope((scope) =>
        scope.setUser({
          id: me.id,
          username: me.id,
          email: me.email,
          ip_address: me._ip,
        }),
      )

    hb_api.hb_trackQuotesFromLocalStorage(me.email)
    await hubspot.hbapi_trackQuotesFromLocalStorage(me.email)

    return token
  } catch (error) {
    console.error('Login error:', error);
    console.error('Error response:', error.response);
    throw error;
  }
}

export const forgotPassword = async (userName) => {
  const params = {
    id_customer: userName,
    language: getBaseLanguageCode(window.document.documentElement.lang),
  }

  const {data} = await axios.post(
    getApiUrl() + '/customer/recoverPasswordEmail',
    params,
  )
  return data
}

export const changePassword = async (
  token,
  timestamp,
  customerId,
  password,
) => {
  const params = {
    resetToken: token,
    timestamp: timestamp,
    id_customer: customerId,
    password: password,
  }
  const {data} = await axios.post(
    getApiUrl() + '/customer/recoverPassword',
    params,
  )
  return data
}

export const sendMessage = async (
  name,
  email,
  subject,
  message,
  files,
  currency,
  timeZone,
  timezoneName,
) => {
  // Initialize default quote data if it doesn't exist
  let defaultData
  try {
    defaultData = await getInstantQuoteDefault()
  } catch (error) {
    console.error('sendMessage: error getting default data:', error)
    defaultData = {countryISO: 'IT'} // fallback
  }
  
  // Handle subject - it could be an object with id or a string
  const subjectValue = typeof subject === 'object' && subject?.id ? subject.id : 
                      typeof subject === 'string' ? subject : 'quote'
  
  // Handle timeZone - it could be an object with id or a string
  const timeZoneValue = typeof timeZone === 'object' && timeZone?.id ? timeZone.id : 
                       typeof timeZone === 'string' ? timeZone : '+1'
  
  // Handle currency - it could be an object with id or a string
  const currencyValue = typeof currency === 'object' && currency?.id ? currency.id : 
                       typeof currency === 'string' ? currency : 'EUR'
  
  const params = {
    name: name,
    email: email,
    subject: subjectValue,
    body: message,
    files: files && Array.isArray(files) && files.length > 0 ? files.join(',') : '',
    currency: currencyValue,
    timezone: timeZoneValue,
    timezoneName,
    language: getBaseLanguageCode(window.document.documentElement.lang),
    country: defaultData?.countryISO || 'IT',
    cookie_utm: getCookie('VITE_COOKIE_UTM') || '',
  }

  try {
    const {data} = await axios.post(
      getApiUrl() + '/contact/sendMessage',
      params,
    )
    return data
  } catch (error) {
    console.error('sendMessage: API call failed:', error)
    console.error('sendMessage: error response:', error.response)
    console.error('sendMessage: error status:', error.response?.status)
    console.error('sendMessage: error data:', error.response?.data)
    throw error
  }
}

export const sendEmailSworn = async (payload) => {
  const {data} = await axios.post(
    getApiUrl() + '/contact/sworn',
    payload,
  )
  return data
}

export const getInstantQuoteDefault = async () => {
  const storedInstantQuoteDefault = storage.getInstantQuoteDefault()
  const isStoredInstantQuoteDefaultValid =
    storedInstantQuoteDefault &&
    storedInstantQuoteDefault.expiration &&
    isBefore(new Date(), new Date(storedInstantQuoteDefault.expiration))

  if (isStoredInstantQuoteDefaultValid) {
    return storedInstantQuoteDefault
  } else {
    storage.clearInstantQuoteDefault()

    const {data} = await axios.post(
      getApiUrl() + '/utils/getDefaults',
      {},
    )
    storage.storeInstantQuoteDefault(
      Object.assign({}, data, {expiration: addHours(new Date(), 1)}),
    )
    return data
  }
}

export const getTranslatorsCountForLanguages = async (source, target) => {
  const params = {
    source: source.id,
    target: target.map((language) => language.id).join(','),
  }

  const {data} = await axios.post(
    getApiUrl() + '/utils/getTranslatorsCountForLanguage',
    params,
  )
  return data
}

export const getStats = async () => {
  const storedStats = storage.getStats()

  const isStoredStatsValid =
    storedStats &&
    storedStats.expiration &&
    isBefore(new Date(), new Date(storedStats.expiration))

  if (isStoredStatsValid) {
    const result = await new Promise((resolve) => {
      setTimeout(() => resolve(storedStats), 0)
    })
    return result
  } else {
    storage.clearStats()

    const {data} = await axios.post(getApiUrl() + '/utils/getStats')
    storage.storeStats(
      Object.assign({}, data, {expiration: addHours(new Date(), 1)}),
    )
    return data
  }
}

